import { Sender } from '@ant-design/x';
import styled from 'styled-components';

export const StyledSender = styled(Sender)<{ $primary?: string }>`
  background: #EFEEF1;
  color: #0D0A0A;
  display: flex;
  border-radius: 0.875rem;
  min-height: 3rem !important;
  margin-left: 0.2rem;

  .ant-sender-content {
    padding: 0.375rem 0.375rem 0.375rem 0.438rem;
  }

  .ant-sender-actions-list {
    .ant-sender-actions-btn {
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 0.688rem;
      background: ${({ $primary }) => $primary || '#E23A00'};
      border-color: ${({ $primary }) => $primary || '#E23A00'};
      box-shadow: none;
      color: #FFFFFF;

      .anticon,
      svg {
        transform: scale(1.2);
        color: inherit;
      }

      &:hover,
      &:focus {
        background: ${({ $primary }) => $primary || '#E23A00'} !important;
        border-color: ${({ $primary }) => $primary || '#E23A00'} !important;
        color: #FFFFFF !important;
      }

      &:hover .anticon,
      &:focus .anticon,
      &:hover svg,
      &:focus svg {
        color: inherit !important;
      }
    }
  }

  .ant-sender-input {
    font-size: 1rem;
    overflow-y: auto !important;

    &::-webkit-scrollbar {
      width: 0.25rem;
    }

    &::-webkit-scrollbar-track {
      background: #EFEEF1;
      border-radius: 0.25rem;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--main-color);
      border-radius: 0.25rem;
    }
  }
`;
